export enum FileType {
    DOCUMENT = 'document_proof',
    GALARY = 'image_gallery_primary',
    LOGO = 'logo',
}
